import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Save, Send } from "lucide-react";
import { toast } from "sonner";
import { LabelFormatSelect } from "@/components/LabelFormatSelect";

// Einstellungen → Versand: Standard-Labelformat + Hinweistext in der Versandmitteilung bei angehängter Rechnung
export const VersandMailSettings = ({ canEdit }) => {
  const [f, setF] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/versand/einstellungen").then((r) => setF({ label_format: r.data.label_format, rechnung_hinweis: r.data.rechnung_hinweis })).catch(() => {}); }, []);
  if (!f) return null;

  const save = async () => {
    setSaving(true);
    try { const r = await api.put("/versand/einstellungen", f); setF({ label_format: r.data.label_format, rechnung_hinweis: r.data.rechnung_hinweis }); toast.success("Versand-Einstellungen gespeichert."); }
    catch (e) { toast.error(e?.response?.data?.detail || "Speichern fehlgeschlagen."); }
    finally { setSaving(false); }
  };

  return (
    <Card className="border-slate-200" data-testid="versand-settings-card">
      <CardHeader><CardTitle className="text-base flex items-center gap-2"><Send className="w-4 h-4" /> Versand: Label &amp; Versandmitteilung</CardTitle></CardHeader>
      <CardContent className="space-y-4">
        <div className="max-w-sm">
          <LabelFormatSelect label="Standard-Labelformat" value={f.label_format} onChange={(v) => setF({ ...f, label_format: v })} disabled={!canEdit} testId="versand-settings-label-format" />
          <p className="text-xs text-slate-500 mt-1">Vorauswahl im Versand-Dialog; je Sendung änderbar und gespeichert (auch für Retouren-Labels).</p>
        </div>
        <div>
          <Label htmlFor="versand-settings-hinweis">Hinweis in der Versandmitteilung, wenn die Rechnung angehängt ist</Label>
          <Input id="versand-settings-hinweis" value={f.rechnung_hinweis} onChange={(e) => setF({ ...f, rechnung_hinweis: e.target.value })} disabled={!canEdit} placeholder="leer = kein Hinweis" data-testid="versand-settings-hinweis" />
        </div>
        {canEdit && <Button onClick={save} disabled={saving} data-testid="versand-settings-save"><Save className="w-4 h-4 mr-2" /> Speichern</Button>}
      </CardContent>
    </Card>
  );
};
